// src/auth/fetchInterceptor.js
// ↑ изменено: добавлен pre-refresh, если access отсутствует, но есть refresh
import { getAccess, getRefresh, clearTokens } from './tokenStorage'; // ↑ изменено: добавили getRefresh
import { refreshAccessToken, setOnLogout } from './tokenManager';

const AUTH_ENDPOINTS = [
  '/api/sign-in/',
  '/api/register/',
  '/api/token/refresh/',
];

function isApiRequest(urlLike) {
  try {
    const url = typeof urlLike === 'string' ? urlLike : urlLike?.url;
    return typeof url === 'string' && url.startsWith('/api/');
  } catch {
    return false;
  }
}

function isAuthEndpoint(urlLike) {
  const url = typeof urlLike === 'string' ? urlLike : urlLike?.url || '';
  return AUTH_ENDPOINTS.some((ep) => url.includes(ep));
}

function mergeHeaders(orig, patch) {
  const h = new Headers(orig || {});
  Object.entries(patch || {}).forEach(([k, v]) => {
    if (typeof v !== 'undefined' && v !== null) h.set(k, v);
  });
  return h;
}

export function installFetchInterceptor({ loginPath = '/sign-in' } = {}) {
  if (typeof window === 'undefined' || !window.fetch) return;
  if (window.__fetchPatched) return;
  window.__fetchPatched = true;

  setOnLogout(() => {
    clearTokens();
    if (typeof window !== 'undefined') {
      window.location.href = loginPath;
    }
  });

  const originalFetch = window.fetch.bind(window);

  window.fetch = async (input, init = {}) => {
    const api = isApiRequest(input);
    const authEp = isAuthEndpoint(input);
    const shouldAttachAuth = api && !authEp;

    // Базовые заголовки
    const baseHeaders =
      init?.headers ||
      (input instanceof Request ? input.headers : undefined) ||
      undefined;

    let headers = new Headers(baseHeaders);

    // ↑ изменено: PRE-REFRESH до первого запроса
    if (shouldAttachAuth && !headers.has('Authorization')) {
      let access = getAccess();
      if (!access) {
        const hasRefresh = !!getRefresh();
        if (hasRefresh) {
          try {
            await refreshAccessToken();        // single-flight внутри
            access = getAccess();              // обновился из tokenStorage
          } catch {
            // refresh провален -> onLogout уже сработал; отправим исходный запрос (вернёт 401)
          }
        }
      }
      if (access) {
        headers.set('Authorization', `Bearer ${access}`);
      }
    }

    const firstInit = { ...init, headers };

    let response = await originalFetch(input, firstInit);

    if (!shouldAttachAuth || response.status !== 401) {
      return response;
    }

    // 401: пробуем обычный refresh + один ретрай
    try {
      await refreshAccessToken();
    } catch {
      return response; // logout уже произошёл
    }

    const retryHeaders = mergeHeaders(headers, {
      Authorization: `Bearer ${getAccess()}`,
    });
    const retryInit = { ...init, headers: retryHeaders };
    return originalFetch(input, retryInit);
  };
}

installFetchInterceptor();
